<template>
  <div>
    <wc-page-title title='Journal Entry'>
      <template v-slot:rightSide>
        <wc-posted :posted='true'></wc-posted>
      </template>

    </wc-page-title>
    <v-container v-if='entry'>
      <v-row>
        <v-col cols='12' md='6'>
          <wc-data-box
            title='Description'
            :showEdit='false'
            @edit='false'
          >
            <v-card-text>
              <span v-if='entry.description' >{{ entry.description }}</span>
              <span v-else class='font-weight-bold'>Description</span>
            </v-card-text>
          </wc-data-box>
        </v-col>
       <v-col cols='12' md='3'>
          <wc-data-box
            title='Posting Date'
            titleIcon='mdi-calendar'
            :showEdit='false'
          >
            <div class='headline text-center my-4'>{{ entry.posting_date | longDate }}</div>
          </wc-data-box>
        </v-col>
        <v-col cols='12' md='3' class='text-right'>
          <v-btn
            large
            block
            :disabled='reverseDisabled()'
            :elevation='3'
            color='error'
            @click='showConfirmReversal = true'
          >
            <v-icon left>mdi-refresh</v-icon>
            Reverse Entry
          </v-btn>
        </v-col>
       </v-row>
      <v-row>
        <v-col cols='12'>
          <wc-data-box title='Lines' :showAdd='false'>
            <v-simple-table dense>
              <thead>
                <tr class='overline'>
                  <th>Account</th>
                  <th>Description</th>
                  <th width='120' class='text-right'>Debit</th>
                  <th width='120' class='text-right'>Credit</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for='line in lines' :key='line.id'>
                  <td v-if='line.account'>{{ line.account_data.name }}</td>
                  <td v-else>(no account)</td>
                  <td>{{ line.description }}</td>
                  <td class='text-right'>{{ line.debit | reportAmount }}</td>
                  <td class='text-right'>{{ line.credit | reportAmount }}</td>
                  <td></td>
                </tr>
              </tbody>
              <tbody>
                <tr class='overline grey lighten-4'>
                  <td></td>
                  <td></td>
                  <td width='120' class='text-right'>{{ entry.debits }}</td>
                  <td width='120' class='text-right'>{{ entry.credits }}</td>
                  <td></td>
                </tr>
              </tbody>
            </v-simple-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

    <wc-confirm
      :showDialog='showConfirmReversal'
      title='Confirm Reversal'
      @cancel='showConfirmReversal = false'
      @confirm='reverseJournalEntry'
    >
      Are you sure you want to reverse this journal entry?<br>
      <br>
      The CPM will create a new entry for the same date,
      but with all journal entry lines in the opposite direction.<br>
      <br>
      <strong>This cannot be undone!</strong>
    </wc-confirm>

    <v-dialog
      v-model='showReversing'
      hide-overlay
      persistent
      width='300'
      :retain-focus='false'
    >
      <v-card color="primary" dark>
        <v-card-text class='pt-2'>
          Reversing...
          <v-progress-linear
            indeterminate
            color="white"
            class="mt-1 mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import accountingAPI from '@/api/accounting';
import WCPosted from '@/components/chips/WCPosted';
import formRules from '@/mixins/formRules';

export default {
  name: 'journal-entry',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    showReversing: false,
    showConfirmReversal: false,
    lines: [],
    entry: null
  }),
  mounted(){
    this.getData();
  },
  watch: {
    '$route' () {
      this.getData()
    }
  },
  methods: {
    async getData(){
      this.isLoading = true;
      const res = await accountingAPI.getJournalEntry(this.$route.params.id);
      this.entry = res;
      const lines_res = await accountingAPI.getJournalEntryLines(this.$route.params.id);
      this.lines = lines_res;
      console.log(this.entry.reversing_entry === true);
      this.isLoading = false;
    },
    async reverseJournalEntry(){
      this.showConfirmReversal = false;
      this.showReversing = true;
      this.entry.can_edit = false;
      this.entry.reversing_entry = true;
      await accountingAPI.updateJournalEntry(this.entry.id, this.entry);
      this.entry.reversing_entry = true;

      accountingAPI.createJournalEntry(this.entry);

      for (let i = 0; i < this.lines.length; i++) {
        const old_debit = this.lines[i].debit
        this.lines[i].debit = this.lines[i].credit
        this.lines[i].credit = old_debit;
        this.lines[i].journal_entry = this.entry.id;
        accountingAPI.createJournalEntryLineItem(this.lines[i]);
      }
      this.showReversing = false;
    },
    reverseDisabled(){
      return this.entry.reversing_entry === true;
    }
  },
  components: {
    'wc-posted': WCPosted
  }
}
</script>
